import { CSSProperties, ReactNode } from "react";
import styled from "@emotion/styled";
import { GrEmpty, GrEmptyProps, GrStack, palette } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";

export type InformationGuideProps = {
  title?: string;
  description?: string;
  emptyType?: GrEmptyProps["type"];
  confirmButton?: ReactNode;
  style?: CSSProperties;
};

export function InformationGuide({
  title = MvnMessage(DOCS_FOLDER_LANG.DOCS_FOLDER_NO_DATA_TITLE),
  description = MvnMessage(DOCS_FOLDER_LANG.DOCS_FOLDER_NO_DATA_DESCRIPTION),
  emptyType = "noData",
  confirmButton,
  style,
}: InformationGuideProps) {
  return (
    <InformationGuideSection style={{ ...(style ?? {}) }}>
      <GrStack
        style={{ textAlign: "center" }}
        flexDirection="column"
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        gap="20px"
      >
        <GrEmpty type={emptyType} title={title} description={description} />
        {confirmButton}
      </GrStack>
    </InformationGuideSection>
  );
}

const InformationGuideSection = styled("section")`
  background-color: ${palette["white"]};
  border-radius: 6px;
`;
